import React from "react";
import { displayCurrency, displayFloatAmount } from "../services/functions";

export function displayAmount(amount, currencyCode) {
  let montant = (
    <span className={`amount ${amount > 0 ? "positive" : "negative"}`}>
      {displayFloatAmount(amount)} {displayCurrency(currencyCode)}
    </span>
  );

  return montant;
}
